module.exports = __webpack_public_path__ + "static/img/NVME-D50RFZhg.ce4221c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/NVME-D50RFZhg.png
// module id = ZmEp
// module chunks = 16